"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = calculateCurrentProgress;

function calculateCurrentProgress(_ref) {
  var value = _ref.value,
      end = _ref.end,
      start = _ref.start;

  var _float = value.toFloat();

  if (value.validate()) {
    if (_float > end) {
      _float = end;
    } else if (_float < start) {
      _float = start;
    }
  } else {
    _float = start;
  }

  return (_float - start) / (end - start) * 100;
}